import DateFormatter from "../../../utils/DateFormatter";


export default class InboundPaymentRequest {

  constructor(jsonResponse) {
    this.id = jsonResponse["id"];
    this.inboundTransactionId = jsonResponse["inbound-transaction-id"];
    this.userId = jsonResponse["user-id"];
    this.requestDate = DateFormatter.FormatTransactionCardDate(jsonResponse["request-date"]);
    this.requestDateTime = jsonResponse["request-date"];
    this.paymentTimeFrame = jsonResponse["payment-time-frame"]
  }

}
